import { render, staticRenderFns } from "./scholarAnalysis.vue?vue&type=template&id=4b7c0b35&scoped=true&"
import script from "./scholarAnalysis.vue?vue&type=script&lang=js&"
export * from "./scholarAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./scholarAnalysis.vue?vue&type=style&index=0&id=4b7c0b35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7c0b35",
  null
  
)

export default component.exports